import lowerCase from 'lodash/lowerCase'

const labelCreator = {
  'MATCH': 'Matches',
  'NOT_MATCH': 'Does not match',
  'IN': 'One of',
  'GREATER_THAN': 'Greater than',
  'GREATER_THAN_OR_EQUAL': 'Greater than or equal to',
  'LESS_THAN': 'Less than',
  'LESS_THAN_OR_EQUAL': 'Less than or equal to',
  'IN_RANGE': 'In range',
}

export const getLabelForOperators = (l) => {
  return labelCreator[l] || (l.charAt(0).toUpperCase() + lowerCase(l).slice(1))
}



// WEBPACK FOOTER //
// ./src/utils/operators.js